export default {
  csrf: (state) => state.csrf,
  token: (state) => state.token,
  user: (state) => state.user,
  logs: (state, getters) => (getters.user && getters.user.logs) ?? [],
  isRoot: (state, getters) => getters.user && getters.user.persona.es_root,
  isAdmin: (state, getters) => getters.user && getters.user.persona.es_admin,
  full_name(state, getters) {
    return (getters.user && getters.user.persona.nombre_completo) || "";
  },
  imagen_url: (state, getters) => getters.user && getters.user.persona.imagen_url
};
